export default __webpack_public_path__ + "static/media/ico_patient_profile.bb6fb0d6.svg";